import Image from '@/components/UI/Image';
import EFArrowUp from '@/components/UI/svg/Icons/EFArrowUp';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
const { EFPic } = createEFPic('/media/deltapro/pc/');

export default function Section12() {
    const { Link, useLang, useRouter } = useGlobal();
    const { t } = useLang('delta_pro_new');
    const { t: s } = useLang('shared');
    const { locale } = useRouter();

    const EV_LINK: any = {
        us: `https://${locale}.ecoflow.com/products/ev-x-stream-adapter-delta-pro`,
        cis: 'none',
        sa: 'none',
        jp: 'https://jp.ecoflow.com/products/ev-adapter',
        cn: 'https://item.jd.com/10055429332973.html#none',
        kr: 'none',
        br: 'none',
        mx: 'none',
        ph: 'none',
    };

    const shopList = [
        {
            key: 0,
            title: t('smart_home_panel'),
            imgPath: ['section_11_1.webp', 'section_11_1.png'],
            link: ['kr', 'br', 'mx', 'ph', 'eu'].includes(locale) ? 'none' : '/smart-home-panel',
        },
        {
            key: 1,
            title: t('EV_adapter'),
            imgPath: ['section_11_2.webp', 'section_11_2.png'],
            link: EV_LINK[locale] || EV_LINK.us,
        },
    ];

    // US/CA和日本显示 double voltage hub
    const hasDvhCountrys = ['us', 'ca', 'jp', 'br', 'mx'];

    // 特定站点删除Double Voltage Hub
    if (hasDvhCountrys.includes(locale)) {
        shopList.push({
            key: 2,
            title: t('DV_hub'),
            imgPath: ['section_11_3.webp', 'section_11_3.png'],
            link:
                locale === 'jp'
                    ? 'https://jp.ecoflow.com/products/double-voltage-hub'
                    : ['us', 'ca']?.includes(locale)
                    ? `https://${locale}.ecoflow.com/products/double-voltage-hub-ecoflow-delta-pro`
                    : '',
        });
    }

    // ca cn 删除smart home panel
    if (['ca', 'cn'].includes(locale)) {
        shopList.shift();
    }

    return (
        <div
            className={`${css.section12} GtmModuleData-section`}
            data-section-id={css.section12}
            data-section-title={t.rich('infinity_port_sub_title_pc', {
                line1: (child: string) => child,
            })}
        >
            <h4 className="subTitle font-family-extrabold">
                <Image src="/media/deltapro/pc/icon/08-infinity-port-icon.svg" width={54} height={54} alt="" />
                <span>{t('infinity_port')}</span>
            </h4>
            <h2 className="mainTitle font-family-bold">
                {t.rich('infinity_port_sub_title_pc', {
                    line1: (child: string) => <strong>{child}</strong>,
                })}
            </h2>
            <p className="text font-family-semibolder">{t('infinity_port_desc')}</p>
            <ul className={`shopList ${shopList.length === 2 ? 'hideOne' : ''}`}>
                {shopList.map((shop) => (
                    <li key={shop.key} className="shopItem">
                        <div className="img">
                            <EFPic name={shop.imgPath} alt={shop.title} aria-label={shop.title} />
                        </div>
                        <h5 className="title font-family-semibolder">{shop.title}</h5>
                        {shop?.link !== 'none' && shop?.link && (
                            <Link
                                className="GtmModuleData-btn-href"
                                href={shop.link}
                                datalayer={{
                                    __btn_id1: css.section12,
                                    __btn_id2: shop.link,
                                }}
                            >
                                <button className="link font-family-regular">
                                    <span>{s('support.site_support_learn_more')}</span>
                                    <EFArrowUp />
                                </button>
                            </Link>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
}
